import {
  Action,
  ActionType,
  IReadHistoryResponse,
} from "models/messagemanagement/messageReadHistory";
import createReducer from "../../createReducer";

export interface ReadHistoryListReducerType {
  loading: boolean;
  error?: string;
  readHistoryListResponse?: IReadHistoryResponse;
}

const defaultState: ReadHistoryListReducerType = {
  loading: false,
  error: undefined,
  readHistoryListResponse: undefined,
};

export const readHistoryListReducer = createReducer<ReadHistoryListReducerType>(
  defaultState,
  {
    [ActionType.READ_HISTORY_LIST](state: ReadHistoryListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.READ_HISTORY_LIST_ERROR](
      state: ReadHistoryListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.READ_HISTORY_LIST_SUCCESS](
      state: ReadHistoryListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        readHistoryListResponse: action.payload,
      };
    },
  }
);
